interface ProductionEventColorProperties {
  label: string;
  backgroundColor: string;
  borderColor?: string;
  textColor: string;
}

const noProductionEventColor = {
  label: 'No Color',
  backgroundColor: '#f8f9fa',
  borderColor: '#6c757d',
  textColor: '#212529',
} as const;

export const productionEventColors = {
  brown: {
    label: 'Brown',
    backgroundColor: '#6d340c',
    textColor: 'white',
  },
  purple: {
    label: 'Purple',
    backgroundColor: '#6a3499',
    textColor: 'white',
  },
  pink: {
    label: 'Pink',
    backgroundColor: '#d80c8f',
    textColor: 'white',
  },
  blue: {
    label: 'Blue',
    backgroundColor: '#449fe3',
    textColor: 'white',
  },
  green: {
    label: 'Green',
    backgroundColor: '#0ca34f',
    textColor: 'white',
  },
  yellow: {
    label: 'Yellow',
    backgroundColor: '#eace2a',
    textColor: 'black',
  },
  orange: {
    label: 'Orange',
    backgroundColor: '#f4891e',
    textColor: 'black',
  },
  gray: {
    label: 'Gray',
    backgroundColor: '#6c757d',
    textColor: 'white',
  },
} as const;

export type ProductionEventColor = keyof typeof productionEventColors;

export function getProductionEventColor(
  productionEventColor?: ProductionEventColor | null
): ProductionEventColorProperties {
  if (!productionEventColor) {
    return noProductionEventColor;
  }

  return productionEventColors[productionEventColor] ?? noProductionEventColor;
}
